import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';


class fondoFijoEstadoService {

    async listarEstado(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/fondo-fijo-estado/listar-estado?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }
}

export default new fondoFijoEstadoService();